import React from 'react';
import { Box, Typography } from '@mui/material';

interface MappingRowProps {
  leftLabel: string;
  leftValue: string;
  rightLabel: string;
  rightContent: React.ReactNode;
}

export const MappingRow: React.FC<MappingRowProps> = ({
  leftLabel,
  leftValue,
  rightLabel,
  rightContent,
}) => (
  <Box
    sx={{
      display: 'flex',
      gap: 2,
      alignItems: 'center',
      p: 2,
      backgroundColor: 'grey.50',
      borderRadius: 1,
    }}
  >
    <Box sx={{ flex: 1 }}>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
        {leftLabel}
      </Typography>
      <Typography variant="body1" fontWeight="medium">
        {leftValue}
      </Typography>
    </Box>
    <Box sx={{ flex: 1 }}>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
        {rightLabel}
      </Typography>
      {rightContent}
    </Box>
  </Box>
);
